/* CellConnectZA: fit real navigation links into a single desktop row. */
(() => {
  'use strict';
  if (window.ccDesktopLayoutV2) { window.ccDesktopLayoutV2.refresh(); return; }
  const desktop = window.matchMedia('(min-width: 861px)');
  let nav, header, more, overflow, links = [], frame = 0, resizeObserver;
  function schedule() {
    if (!frame) frame = requestAnimationFrame(() => { frame = 0; fit(); });
  }
  function fit() {
    if (!nav || !nav.isConnected || !header) return;
    const seen = new Set(links);
    nav.querySelectorAll('a').forEach(link => { if (!seen.has(link)) links.push(link); });
    links = links.filter(link => link.isConnected);
    // Preserve the existing anchors, destinations and click handlers.
    links.forEach(link => nav.insertBefore(link, more));
    more.hidden = true;
    more.open = false;
    if (desktop.matches) {
      const available = nav.clientWidth;
      const widths = links.map(link => link.getBoundingClientRect().width);
      let used = widths.reduce((a, b) => a + b, 0);
      if (used > available - 4) {
        more.hidden = false;
        used += more.getBoundingClientRect().width;
        let keep = links.length;
        while (keep > 2 && used > available - 4) { keep--; used -= widths[keep]; }
        links.slice(keep).forEach(link => overflow.appendChild(link));
      }
      const height = Math.ceil(header.getBoundingClientRect().height);
      if (height > 0) document.documentElement.style.setProperty('--cc-desktop-header-height', height + 'px');
    }
  }
  function connect() {
    const next = document.getElementById('h-nav');
    header = document.getElementById('h');
    if (!next || !header) return;
    if (next !== nav) {
      nav = next;
      links = Array.from(nav.children).filter(el => el.tagName === 'A');
      more = document.createElement('details');
      more.className = 'cc-nav-more';
      more.hidden = true;
      const summary = document.createElement('summary');
      summary.textContent = 'More';
      summary.setAttribute('aria-label', 'More navigation links');
      overflow = document.createElement('div');
      overflow.className = 'cc-nav-more__links';
      more.append(summary, overflow);
      nav.appendChild(more);
      if (resizeObserver) resizeObserver.disconnect();
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(schedule);
        resizeObserver.observe(header);
        resizeObserver.observe(nav);
      }
    }
    schedule();
  }
  window.ccDesktopLayoutV2 = {version: '2.0.0', refresh: connect};
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('click', event => {
    if (more && more.open && (!more.contains(event.target) || event.target.closest('a'))) more.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && more && more.open) {
      more.open = false;
      more.querySelector('summary').focus();
    }
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  window.addEventListener('load', schedule, {once: true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, {once: true});
  else connect();
})();
